import { destroy, mutate, query, update, uploadFile } from "../../defaults/fetch";
import { useState, useEffect } from "react";


export const getBudgetItems = async (headId, page = 0, size = 50) => {
  const qs = {
    budget_category: headId,
    page: page,
    size: size
  };
  const url = `subaccount/get-all`;
  const { data } = await query(url, qs);
  return data;
}

export const useGetAllBudgetItemsUnpaginated = () => {
  const getItemsUnPaginated = async (flow) => {
    const url = `subaccount/all`
    const q = {
      flow: flow
    }
    const { data } = await query(url, q)
    return data
  }

  return getItemsUnPaginated
}


export const useGetAlltBudgetItems = (flag) => {
  const [budgetItems, setBudgetItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAllBudgetItems = async () => {
      const qs = {
        page: 0,
        size: 4000
      };
      setLoading(true);
      const url = `subaccount/get-all`;
      const { data } = await query(url, qs);
      setLoading(false);
      setBudgetItems(data.content);
    }
    getAllBudgetItems();
  }, [flag])

  return { loading, budgetItems };
}


export const useCreateBudgetItem = () => {
  const createBudgetItem = async (body) => {
    const url = `subaccount/create`;
    const { message } = await mutate(url, true, body);
    return message;
  }
  return createBudgetItem;
}

export const useUpdateItem = () => {
  const updateItem = async (id, body) => {
    const url = `subaccount/update/${id}`;
    const { message } = await update(url, body);
    return message;
  }
  return updateItem;
}

export const useUploadItems = () => {
  const uploadItems = async (formData) => {
    const url = `subaccount/upload`;
    const { message } = await uploadFile(url, formData);
    return message;
  }

  return uploadItems;
}



export const useDeleteBudgetItem = () => {
  const deleteBudgetItem = async (id) => {
    const url = `subaccount/delete/${id}`;
    const { message } = await destroy(url);
    return message;
  }
  return deleteBudgetItem;
}
